/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RevokeConsentRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {ConsentDecisionResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const revokeConsent = (request:RevokeConsentRequest, options?: CashRequestOptions) => post<RevokeConsentRequest, ConsentDecisionResponse>("/2.0/cash/revoke-consent", request, {...options, rejectOnError: true })